import { render } from "./ProgressMetric.vue?vue&type=template&id=1c2c8578"
import script from "./ProgressMetric.vue?vue&type=script&lang=js"
export * from "./ProgressMetric.vue?vue&type=script&lang=js"

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ProgressMetric.vue"]])

export default __exports__